import {
  FETCH_FAILED_REDEMPTIONS_START,
  FETCH_FAILED_REDEMPTIONS_COMPLETE,
  FETCH_FAILED_REDEMPTIONS_ERROR,
  BATCH_RETRY_REDEEM_REWARD_START,
  BATCH_RETRY_REDEEM_REWARD_PROGRESS,
  BATCH_RETRY_REDEEM_REWARD_COMPLETE,
  BATCH_RETRY_REDEEM_REWARD_ERROR,
  CLEAR_FAILED_REDEMPTIONS_STATE,
  FETCH_MERGE_WALLET_DATA_START,
  FETCH_MERGE_WALLET_DATA_COMPLETE,
  FETCH_MERGE_WALLET_DATA_ERROR,
  MERGE_WALLET_START,
  MERGE_WALLET_COMPLETE,
  MERGE_WALLET_ERROR,
  CLEAR_MERGE_WALLET_STATE,
  FETCH_CAREGIVER_BY_PHONE_START,
  FETCH_CAREGIVER_BY_PHONE_COMPLETE,
  FETCH_CAREGIVER_BY_PHONE_ERROR,
  CHANGE_EMPLOYEE_PASSWORD_START,
  CHANGE_EMPLOYEE_PASSWORD_COMPLETE,
  CHANGE_EMPLOYEE_PASSWORD_ERROR,
  CLEAR_CHANGE_PASSWORD_STATE,
  FETCH_REWARD_CONFIG_LIST_START,
  FETCH_REWARD_CONFIG_LIST_COMPLETE,
  FETCH_REWARD_CONFIG_LIST_ERROR,
  MANUAL_REDEMPTION_START,
  MANUAL_REDEMPTION_COMPLETE,
  MANUAL_REDEMPTION_ERROR,
  CLEAR_MANUAL_REDEMPTION_STATE,
  UPDATE_PRIMARY_PHONE_START,
  UPDATE_PRIMARY_PHONE_COMPLETE,
  UPDATE_PRIMARY_PHONE_ERROR,
  CLEAR_UPDATE_PRIMARY_PHONE_STATE,
  FETCH_TANGO_TOTAL_BALANCE_START,
  FETCH_TANGO_TOTAL_BALANCE_COMPLETE,
  FETCH_TANGO_TOTAL_BALANCE_ERROR,
} from './actions';
import { LOGOUT } from '../login/actions';

let initialState = {
  isFetchFailedRedemptionsStarted: false,
  failedRedemptionsData: undefined,
  failedRedemptionsError: undefined,
  isBatchRetryRedeemRewardStarted: false,
  batchRetryRedeemRewardSuccess: false,
  batchRetryRedeemRewardError: undefined,
  batchRetryRedeemRewardResult: undefined,
  inProgressRewardOrderIds: [],
  isFetchMergeWalletDataStarted: false,
  mergeWalletData: undefined,
  mergeWalletError: undefined,
  isMergeWalletStarted: false,
  mergeWalletSuccess: false,
  mergeWalletResponse: undefined,
  mergeWalletApiError: undefined,
  isFetchCaregiverByPhoneStarted: false,
  caregiverData: undefined,
  caregiverError: undefined,
  isChangePasswordStarted: false,
  changePasswordSuccess: false,
  changePasswordError: undefined,
  isFetchRewardConfigListStarted: false,
  rewardConfigList: [],
  rewardConfigListError: undefined,
  isManualRedemptionStarted: false,
  manualRedemptionSuccess: false,
  manualRedemptionError: undefined,
  isUpdatePrimaryPhoneStarted: false,
  updatePrimaryPhoneSuccess: false,
  updatePrimaryPhoneError: undefined,
  isFetchTangoTotalBalanceStarted: false,
  tangoTotalBalance: undefined,
  tangoTotalBalanceError: undefined,
};

const reducer = (state = initialState, { payload, type }) => {
  switch (type) {
    case FETCH_FAILED_REDEMPTIONS_START:
      return {
        ...state,
        isFetchFailedRedemptionsStarted: true,
        failedRedemptionsError: undefined,
        failedRedemptionsData: undefined,
      };
    case FETCH_FAILED_REDEMPTIONS_COMPLETE:
      return {
        ...state,
        isFetchFailedRedemptionsStarted: false,
        failedRedemptionsError: undefined,
        failedRedemptionsData: payload.data,
        failedRedemptionsTotalRecords: payload.totalRecords,
        failedRedemptionsTotalPages: payload.totalPages,
      };
    case FETCH_FAILED_REDEMPTIONS_ERROR:
      return {
        ...state,
        isFetchFailedRedemptionsStarted: false,
        failedRedemptionsError: payload.error,
        failedRedemptionsData: undefined,
      };
    case FETCH_MERGE_WALLET_DATA_START:
      return {
        ...state,
        isFetchMergeWalletDataStarted: true,
        mergeWalletError: undefined,
        mergeWalletData: undefined,
        mergeWalletSuccess: false,
        mergeWalletResponse: undefined,
        mergeWalletApiError: undefined,
      };
    case FETCH_MERGE_WALLET_DATA_COMPLETE:
      return {
        ...state,
        isFetchMergeWalletDataStarted: false,
        mergeWalletError: undefined,
        mergeWalletData: payload.data,
      };
    case FETCH_MERGE_WALLET_DATA_ERROR:
      return {
        ...state,
        isFetchMergeWalletDataStarted: false,
        mergeWalletError: payload.error,
        mergeWalletData: undefined,
      };
    case BATCH_RETRY_REDEEM_REWARD_START:
      {
        const requestedIds = payload?.rewardOrderIds || [];
        return {
          ...state,
          isBatchRetryRedeemRewardStarted: true,
          batchRetryRedeemRewardError: undefined,
          batchRetryRedeemRewardSuccess: false,
          batchRetryRedeemRewardResult: undefined,
          inProgressRewardOrderIds: Array.from(
            new Set([...(state.inProgressRewardOrderIds || []), ...requestedIds]),
          ),
        };
      }
    case BATCH_RETRY_REDEEM_REWARD_PROGRESS:
      {
        const pendingIds = payload?.pendingRewardOrderIds || [];
        return {
          ...state,
          inProgressRewardOrderIds: pendingIds,
          batchRetryRedeemRewardResult: {
            ...(state.batchRetryRedeemRewardResult || {}),
            ...(payload.data || {}),
          },
        };
      }
    case BATCH_RETRY_REDEEM_REWARD_COMPLETE:
      {
        const pendingIds = payload?.pendingRewardOrderIds || [];
        return {
          ...state,
          isBatchRetryRedeemRewardStarted: false,
          batchRetryRedeemRewardError: undefined,
          batchRetryRedeemRewardSuccess: true,
          batchRetryRedeemRewardResult: payload.data,
          inProgressRewardOrderIds: pendingIds,
        };
      }
    case BATCH_RETRY_REDEEM_REWARD_ERROR:
      {
        const pendingIds = payload?.pendingRewardOrderIds || [];
        return {
          ...state,
          batchRetryRedeemRewardError: payload.error,
          isBatchRetryRedeemRewardStarted: false,
          batchRetryRedeemRewardSuccess: false,
          batchRetryRedeemRewardResult: payload?.data || undefined,
          inProgressRewardOrderIds: pendingIds,
        };
      }
    case CLEAR_FAILED_REDEMPTIONS_STATE:
      return {
        ...state,
        isFetchFailedRedemptionsStarted: false,
        failedRedemptionsData: undefined,
        failedRedemptionsError: undefined,
        failedRedemptionsTotalRecords: undefined,
        failedRedemptionsTotalPages: undefined,
        isBatchRetryRedeemRewardStarted: false,
        batchRetryRedeemRewardSuccess: false,
        batchRetryRedeemRewardError: undefined,
        batchRetryRedeemRewardResult: undefined,
        inProgressRewardOrderIds: [],
      };
    case MERGE_WALLET_START:
      return {
        ...state,
        isMergeWalletStarted: true,
        mergeWalletApiError: undefined,
        mergeWalletSuccess: false,
        mergeWalletResponse: undefined,
      };
    case MERGE_WALLET_COMPLETE:
      return {
        ...state,
        isMergeWalletStarted: false,
        mergeWalletSuccess: true,
        mergeWalletApiError: undefined,
        mergeWalletResponse: payload.data,
      };
    case MERGE_WALLET_ERROR:
      return {
        ...state,
        isMergeWalletStarted: false,
        mergeWalletSuccess: false,
        mergeWalletApiError: payload.error,
        mergeWalletResponse: undefined,
      };
    case CLEAR_MERGE_WALLET_STATE:
      return {
        ...state,
        isMergeWalletStarted: false,
        mergeWalletSuccess: false,
        mergeWalletApiError: undefined,
        mergeWalletResponse: undefined,
        mergeWalletData: undefined,
        mergeWalletError: undefined,
        isFetchMergeWalletDataStarted: false,
      };
    case FETCH_CAREGIVER_BY_PHONE_START:
      return {
        ...state,
        isFetchCaregiverByPhoneStarted: true,
        caregiverError: undefined,
        caregiverData: undefined,
      };
    case FETCH_CAREGIVER_BY_PHONE_COMPLETE:
      return {
        ...state,
        isFetchCaregiverByPhoneStarted: false,
        caregiverError: undefined,
        caregiverData: payload.data,
      };
    case FETCH_CAREGIVER_BY_PHONE_ERROR:
      return {
        ...state,
        isFetchCaregiverByPhoneStarted: false,
        caregiverError: payload.error,
        caregiverData: undefined,
      };
    case CHANGE_EMPLOYEE_PASSWORD_START:
      return {
        ...state,
        isChangePasswordStarted: true,
        changePasswordError: undefined,
        changePasswordSuccess: false,
      };
    case CHANGE_EMPLOYEE_PASSWORD_COMPLETE:
      return {
        ...state,
        isChangePasswordStarted: false,
        changePasswordSuccess: true,
        changePasswordError: undefined,
      };
    case CHANGE_EMPLOYEE_PASSWORD_ERROR:
      return {
        ...state,
        isChangePasswordStarted: false,
        changePasswordSuccess: false,
        changePasswordError: payload.error,
      };
    case CLEAR_CHANGE_PASSWORD_STATE:
      return {
        ...state,
        isFetchCaregiverByPhoneStarted: false,
        caregiverData: undefined,
        caregiverError: undefined,
        isChangePasswordStarted: false,
        changePasswordSuccess: false,
        changePasswordError: undefined,
      };
    case FETCH_REWARD_CONFIG_LIST_START:
      return {
        ...state,
        isFetchRewardConfigListStarted: true,
        rewardConfigListError: undefined,
        rewardConfigList: [],
      };
    case FETCH_REWARD_CONFIG_LIST_COMPLETE:
      return {
        ...state,
        isFetchRewardConfigListStarted: false,
        rewardConfigListError: undefined,
        rewardConfigList: payload.data || [],
      };
    case FETCH_REWARD_CONFIG_LIST_ERROR:
      return {
        ...state,
        isFetchRewardConfigListStarted: false,
        rewardConfigListError: payload.error,
        rewardConfigList: [],
      };
    case MANUAL_REDEMPTION_START:
      return {
        ...state,
        isManualRedemptionStarted: true,
        manualRedemptionError: undefined,
        manualRedemptionSuccess: false,
      };
    case MANUAL_REDEMPTION_COMPLETE:
      return {
        ...state,
        isManualRedemptionStarted: false,
        manualRedemptionError: undefined,
        manualRedemptionSuccess: true,
      };
    case MANUAL_REDEMPTION_ERROR:
      return {
        ...state,
        isManualRedemptionStarted: false,
        manualRedemptionError: payload.error,
        manualRedemptionSuccess: false,
      };
    case CLEAR_MANUAL_REDEMPTION_STATE:
      return {
        ...state,
        isFetchRewardConfigListStarted: false,
        rewardConfigList: [],
        rewardConfigListError: undefined,
        isManualRedemptionStarted: false,
        manualRedemptionSuccess: false,
        manualRedemptionError: undefined,
      };
    case UPDATE_PRIMARY_PHONE_START:
      return {
        ...state,
        isUpdatePrimaryPhoneStarted: true,
        updatePrimaryPhoneSuccess: false,
        updatePrimaryPhoneError: undefined,
      };
    case UPDATE_PRIMARY_PHONE_COMPLETE:
      return {
        ...state,
        isUpdatePrimaryPhoneStarted: false,
        updatePrimaryPhoneSuccess: true,
        updatePrimaryPhoneError: undefined,
      };
    case UPDATE_PRIMARY_PHONE_ERROR:
      return {
        ...state,
        isUpdatePrimaryPhoneStarted: false,
        updatePrimaryPhoneSuccess: false,
        updatePrimaryPhoneError: payload.error,
      };
    case CLEAR_UPDATE_PRIMARY_PHONE_STATE:
      return {
        ...state,
        isUpdatePrimaryPhoneStarted: false,
        updatePrimaryPhoneSuccess: false,
        updatePrimaryPhoneError: undefined,
      };
    case FETCH_TANGO_TOTAL_BALANCE_START:
      return {
        ...state,
        isFetchTangoTotalBalanceStarted: true,
        tangoTotalBalance: undefined,
        tangoTotalBalanceError: undefined,
      };
    case FETCH_TANGO_TOTAL_BALANCE_COMPLETE:
      return {
        ...state,
        isFetchTangoTotalBalanceStarted: false,
        tangoTotalBalance: payload.totalBalance,
        tangoTotalBalanceError: undefined,
      };
    case FETCH_TANGO_TOTAL_BALANCE_ERROR:
      return {
        ...state,
        isFetchTangoTotalBalanceStarted: false,
        tangoTotalBalance: undefined,
        tangoTotalBalanceError: payload.error,
      };
    case LOGOUT:
      return initialState;
    default:
      return state;
  }
};

export default reducer;

